import React, { useEffect, useLayoutEffect, useState } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import Image from "components/Elements/Image/Image.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useParams } from "react-router-dom";
import { useUser } from "contexts/userContext/userContext.js";

import "./AccountDeleted.scss";

const AccountDeleted = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const { getTextByKey, getHtmlByKey } = useContent();

  const { isLoggedIn, logout } = useUser();

  useEffect(() => {
    deleteUserData();
  }, [isLoggedIn()]);

  const deleteUserData = async () => {
    setLoading(true);
    const response = await apiRequest(
      "Users",
      `ReactDeleteUserData?Token=${params.token}`,
      null,
      "POST"
    );

    if (response.status !== "success") {
      if (response.data === "passed-date") {
        setError(getHtmlByKey("passed-date"));
      } else {
        setError("error");
      }
    } else {
      if (isLoggedIn()) {
        logout();
      }
    }
    setLoading(false);
  };

  return (
    <div className="account-deleted-wrapper">
      {loading ? (
        <Image
          className="loader-animation-gif"
          name="preloader"
          ext="gif"
          alt=""
          title=""
        />
      ) : error ? (
        <div className="content-wrapper-error">
          <Image name="paper-plane-crushed-circled" ext="svg" />
          {error}
        </div>
      ) : (
        <div className="content-wrapper">
          <Icon name={"blocked"} xxxl />
          {getTextByKey("account-deleted")}
        </div>
      )}
    </div>
  );
};

export default AccountDeleted;
